import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, formatApiError, homePathFor } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Store, Loader2 } from "lucide-react";

export default function Register() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", store_name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      navigate(homePathFor(data), { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="flex items-center justify-center p-6 order-2 lg:order-1">
        <div className="w-full max-w-sm">
          <Link to="/" className="lg:hidden flex items-center gap-2 mb-8">
            <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center text-white"><Store className="w-5 h-5" /></div>
            <span className="font-heading font-extrabold text-xl">KASIRKU</span>
          </Link>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Buat akun toko</h1>
          <p className="mt-2 text-muted-foreground text-sm">Gratis, tanpa kartu kredit. Toko Anda langsung aktif.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="name">Nama Anda</Label>
              <Input id="name" required value={form.name} onChange={set("name")} placeholder="Budi Santoso"
                className="mt-1.5 rounded-lg" data-testid="register-name-input" />
            </div>
            <div>
              <Label htmlFor="store_name">Nama Toko</Label>
              <Input id="store_name" required value={form.store_name} onChange={set("store_name")} placeholder="Toko Berkah Jaya"
                className="mt-1.5 rounded-lg" data-testid="register-store-input" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={form.email} onChange={set("email")} placeholder="nama@email.com"
                className="mt-1.5 rounded-lg" data-testid="register-email-input" />
            </div>
            <div>
              <Label htmlFor="password">Kata Sandi</Label>
              <Input id="password" type="password" required minLength={6} value={form.password} onChange={set("password")} placeholder="Minimal 6 karakter"
                className="mt-1.5 rounded-lg" data-testid="register-password-input" />
            </div>
            {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="register-error">{error}</div>}
            <Button type="submit" disabled={loading} className="w-full rounded-lg h-11" data-testid="register-submit-button">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Daftar & Buat Toko"}
            </Button>
          </form>

          <div className="my-5 flex items-center gap-3 text-xs text-muted-foreground">
            <div className="h-px bg-border flex-1" /> ATAU <div className="h-px bg-border flex-1" />
          </div>
          <Button variant="outline" onClick={googleLogin} className="w-full rounded-lg h-11" data-testid="google-register-btn">
            <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4 mr-2" /> Daftar dengan Google
          </Button>

          <p className="mt-6 text-center text-sm text-muted-foreground">
            Sudah punya akun? <Link to="/login" className="text-primary font-semibold" data-testid="to-login-link">Masuk</Link>
          </p>
        </div>
      </div>

      <div className="hidden lg:flex flex-col justify-between bg-slate-900 text-white p-12 order-1 lg:order-2">
        <Link to="/" className="flex items-center gap-2 self-end">
          <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center"><Store className="w-5 h-5" /></div>
          <span className="font-heading font-extrabold text-xl">KASIRKU</span>
        </Link>
        <div>
          <h2 className="font-heading text-4xl font-bold leading-tight">Mulai kelola toko dalam 1 menit.</h2>
          <p className="mt-4 text-slate-300 max-w-md">Buat akun, tambahkan produk, dan langsung terima transaksi. Semua data toko Anda aman dan terpisah.</p>
        </div>
        <div className="text-slate-400 text-sm">© 2026 KASIRKU</div>
      </div>
    </div>
  );
}
